import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "information-filled-outline-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 7.5, fill: "currentColor", fillOpacity: 0.1 }),
        React.createElement("g", { transform: "translate(7 4.5)" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M.5 4h1v3" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M.5 7h2" }),
            React.createElement("circle", { cx: 1.5, cy: 1, r: 1, fill: "currentColor" }))));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
